import { render, staticRenderFns } from "./ServicePointAddress.vue?vue&type=template&id=06ba195e&scoped=true&"
import script from "./ServicePointAddress.vue?vue&type=script&lang=js&"
export * from "./ServicePointAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba195e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VTextField,VTextarea})
